import React, { useCallback, useContext, useState } from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';
import { ViewportContext } from 'src/components/viewport';
import { usePriceRowContext } from '../../../price-row-context';

import { Direction } from '@prisjakt/ui';
import { ButtonSize, ButtonType } from '@prisjakt/ui/button/variants';
import { DropdownContent, DropdownToggle } from '@prisjakt/ui/dropdown';
import { IconMenuKebab } from '@prisjakt/ui/icon';
import { MediumUp, MobileOnly } from 'src/ui/block';
import ReportModal from '../../components/report-button/report-modal';

import { IOptionsColumn } from './types';

import * as RegularStyle from '../styles';
import { Dropdown, Option, Options, ReportOverlay } from './styles';

const OptionsColumn: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IOptionsColumn>
>> = props => {
  const { alternativeOffer, className } = props;

  const { t } = useAppContext();
  const { isMobile } = useContext(ViewportContext);
  const { isFeatured } = usePriceRowContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      // Stops the PriceRow link and onClick from firing
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => setModalIsOpen(false), [setModalIsOpen]);

  const color = isFeatured ? 'maybeBlue700' : 'base500';

  return (
    <RegularStyle.Column className={className}>
      <ReportModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        priceId={alternativeOffer.id}
        priceValue={
          alternativeOffer.price && alternativeOffer.price.exclShipping
        }
        productName={alternativeOffer.name}
        stockStatus={alternativeOffer.stock && alternativeOffer.stock.status}
      />

      <Options>
        <Dropdown
          closeOnItemClick
          onToggle={(event: Event) => {
            event.stopPropagation();
            event.preventDefault();
          }}
        >
          <DropdownToggle
            onlyIcon
            size={ButtonSize.MEDIUM}
            type={ButtonType.TEXT}
          >
            <MobileOnly>
              <IconMenuKebab color={color} />
            </MobileOnly>

            <MediumUp>
              <IconMenuKebab color={color} />
            </MediumUp>
          </DropdownToggle>

          <DropdownContent placement={isMobile ? Direction.Up : Direction.Down}>
            <ReportOverlay>
              <Option type="button" onClick={openModal}>
                {t('feedback', 'dialog.prompt-button')}
              </Option>
            </ReportOverlay>
          </DropdownContent>
        </Dropdown>
      </Options>
    </RegularStyle.Column>
  );
};

export default OptionsColumn;
